<template>
  <div class="tourFilter">
    <div>
      <!-- キャンペーン（あれば） -->
      <div
        v-for="c in selectedCampaigns"
        :key="c.id"
        class="tourFilter_campaign"
      >
        <span class="tourFilter_selectedIcon" />
        <p class="tourFilter_campaignText">{{ c.title }}</p>
        <span
          class="tourFilter_closeCampaign"
          @click="!isLoadingFacets && disableCampaign(c.id)"
        />
      </div>
      <p
        v-if="title"
        class="tourFilter_title"
      >
        {{ title }}
      </p>

      <div
        class="tourFilter_section"
        :style="{ padding: contentPadding }"
      >
        <div v-if="condition.hasFilters">
          <tk-button
            class="tourFilter_allRemoveButton"
            @click="$emit('input', condition.withoutFilters)"
          >
            <tk-cross-mark
              class="tourFilter_clearAllCrossMark"
              :width="2"
              :length="7"
            />
            絞り込み条件をすべてクリア
          </tk-button>
          <div class="tourFilter_filterBadgesList">
            <filter-condition-badges
              :condition="condition"
              :removable="true"
              @remove="$emit('input', $event)"
            />
          </div>
        </div>
        <div>
          <p :class="['tourFilter_label', { '-noMarginTop': !condition.hasFilters }]">キーワードで検索</p>
          <tk-text-box
            placeholder="例：レンタカー付、温泉 など"
            :value="condition.keyword"
            :size="size"
            :disabled="isLoadingFacets"
            @blur="update(params.KEYWORD, $event.target.value)"
          />
        </div>
        <div>
          <p class="tourFilter_label">予算</p>
          <div class="tourFilter_budget">
            <tk-pulldown
              class="tourFilter_flexPulldown"
              :value="condition.priceFrom ? String(condition.priceFrom) : null"
              :items="[null, ...selectableFilterPrices].map(price => ({
                value: price,
                label: `${price ? price.toLocaleString('ja-JP') : '----'}円`,
              }))"
              :size="size"
              :disabled="isLoadingFacets"
              @change="updatePriceFrom($event)"
            />
            <span class="tourFilter_range"> ～ </span>
            <tk-pulldown
              class="tourFilter_flexPulldown"
              :value="condition.priceTo ? String(condition.priceTo) : null"
              :items="[null, ...selectablePriceTo].map(price => ({
                value: price,
                label: `${price ? price.toLocaleString('ja-JP') : '----'}円`,
              }))"
              :size="size"
              :disabled="isLoadingFacets"
              @change="update(params.PRICE_TO, asNumber($event))"
            />
          </div>
        </div>
        <div>
          <p class="tourFilter_label">人気の絞り込み条件</p>
          <div
            v-if="allFacets.popularIntentions.length > 0"
            class="tourFilter_lpIntentionArea"
          >
            <div
              v-for="{ name, codes } in allFacets.popularIntentions"
              :key="codes.join('|')"
            >
              <checkbox
                :label="name"
                :value="codes"
                :selected="condition.intentionIds"
                @change="updateIntentions($event, codes)"
              />
            </div>
          </div>
        </div>
      </div>

      <p class="tourFilter_sectionLabel">ホテルの詳細を指定する</p>
      <div
        class="tourFilter_section"
        :style="{ padding: contentPadding }"
      >
        <div
          v-for="(destination, index) in destinations"
          :key="`${index}-${destination.name}`"
        >
          <p :class="['tourFilter_label', { '-noMarginTop': index === 0 }]">
            ホテルを指定する{{ destinations.length > 1 ? `（${destination.name}）` : '' }}
          </p>
          <template v-if="selectableHotelsOfDestination(index).length > 0 || hotel[index].term">
            <tk-text-box
              v-model="hotel[index].term"
              placeholder="ホテル名を入力してください"
              :size="size"
              :disabled="isLoadingFacets"
              @focus="openHotelSelect(index)"
            />
            <div v-show="hotel[index].opened">
              <tk-pulldown
                v-if="!destination.city"
                v-model="hotel[index].city"
                class="tourFilter_inputHotelName"
                :items="[{ name: '都市を絞り込む', code: '' }, ...allFacets.cities].map(({ name, code }) => ({
                  value: code,
                  label: name,
                }))"
                :size="size"
                :disabled="isLoadingFacets"
              />
              <div class="tourFilter_hotelListBox">
                <div class="tourFilter_hotelList">
                  <checkbox
                    v-for="{ name, code, rank, tripadvisor } in selectableHotelsOfDestination(index)"
                    :key="code"
                    :label="name"
                    :value="code"
                    :selected="condition.hotelIds"
                    :disabled="isLoadingFacets || !facets.isHotelSelectable(code)"
                    @change="selectHotel($event)"
                  >
                    <template v-slot:label>
                      <span>{{ name }}</span>
                      <tk-star-rating
                        v-if="rank"
                        class="tourFilter_hotelRank"
                        text-class="tourFilter_hotelRankLabel"
                        :star-number="rank"
                      />
                      <tk-icon
                        v-if="tripadvisor"
                        :name="`tripadvisor-${tripadvisor}`"
                        :alt="tripadvisor"
                      />
                    </template>
                  </checkbox>
                </div>
                <p class="tourFilter_closeHotelListArea">
                  <span
                    class="tourFilter_closeHotelList"
                    @click="hotel[index].opened = false"
                  >
                    閉じる
                  </span>
                </p>
              </div>
            </div>
            <div
              v-if="selectedHotelsForEachDestination[index].length > 0"
              class="tourFilter_selectedHotelsArea"
            >
              <div
                v-for="{ name, code } in selectedHotelsForEachDestination[index]"
                :key="code"
                class="tourFilter_selectedHotels"
              >
                <span
                  class="tourFilter_hotelUnselectButton"
                  @click="$emit('input', condition.unselectHotel(code))"
                >
                  削除
                </span>
                <p class="tourFilter_hotelUnselectLabel">{{ name }}</p>
              </div>
            </div>
          </template>
          <p
            v-else
            class="tourFilter_noChoices"
          >
            {{ whyNoHotelsAtDestination(index) }}
          </p>
        </div>
        <div>
          <p class="tourFilter_label">宿泊エリア</p>
          <template v-if="allFacets.accommodationAreas.length > 0 && destinations.length > 0">
            <div
              v-for="{ name, codes } in allFacets.accommodationAreas"
              :key="codes.join('|')"
            >
              <checkbox
                :label="name"
                :value="codes"
                :selected="condition.intentionIds"
                :disabled="!shouldEnableIntentionCheckbox(codes)"
                :strike-through="!facets.withoutPopularIntentions.isIntentionSelectable(codes)
                  && condition.hasIntention(codes)"
                @change="updateIntentions($event, codes)"
              />
            </div>
          </template>
          <p
            v-else
            class="tourFilter_noChoices"
          >
            選択可能なエリアがありません
          </p>
        </div>
        <div>
          <p class="tourFilter_label">ホテルランク</p>
          <ul>
            <li
              v-for="{ name, code } in [{ name: '全て', code: null }, ...selectableHotelRanks]"
              :key="code"
            >
              <input
                :id="`selectRank_${code}`"
                class="tourFilter_radioButton"
                type="radio"
                :value="code"
                name="hotelRankButton"
                :disabled="isLoadingFacets"
                :checked="(condition.minHotelRank || null) === code"
                @change="update(params.MIN_HOTEL_RANK, asNumber($event.target.value))"
              >
              <label
                class="tourFilter_radioButtonLabel"
                :for="`selectRank_${code}`"
              >
              {{ name }}
              </label>
            </li>
          </ul>
        </div>
        <div>
          <p class="tourFilter_label">宿タイプ</p>
          <template v-if="allFacets.hotelTypes.length > 0">
            <div
              v-for="{ name, codes } in allFacets.hotelTypes"
              :key="codes.join('|')"
            >
              <checkbox
                :label="name"
                :value="codes"
                :selected="condition.intentionIds"
                :disabled="!shouldEnableIntentionCheckbox(codes)"
                :strike-through="!facets.withoutPopularIntentions.isIntentionSelectable(codes)
                  && condition.hasIntention(codes)"
                @change="updateIntentions($event, codes)"
              />
            </div>
          </template>
          <p
            v-else
            class="tourFilter_noChoices"
          >
            選択可能な宿タイプがありません
          </p>
        </div>
        <div>
          <p class="tourFilter_label">部屋タイプ/設備</p>
          <template v-if="allFacets.roomFacilities.length > 0">
            <div
              v-for="{ name, codes } in allFacets.roomFacilities"
              :key="codes.join('|')"
            >
              <checkbox
                :label="name"
                :value="codes"
                :selected="condition.intentionIds"
                :disabled="!shouldEnableIntentionCheckbox(codes)"
                :strike-through="!facets.withoutPopularIntentions.isIntentionSelectable(codes)
                  && condition.hasIntention(codes)"
                @change="updateIntentions($event, codes)"
              />
            </div>
          </template>
          <p
            v-else
            class="tourFilter_noChoices"
          >
            選択可能な部屋タイプ/設備がありません
          </p>
        </div>
      </div>

      <p class="tourFilter_sectionLabel">
        {{ condition.isDomestic ? '交通機関の詳細' : 'フライトの詳細' }}を指定する
      </p>
      <div
        class="tourFilter_section"
        :style="{ padding: contentPadding }"
      >
        <checkbox
          v-if="!condition.isDomestic"
          label="直行便"
          :selected="condition.preferDirectFlight"
          :disabled="isLoadingFacets"
          @change="update(params.STOPOVER, $event ? '0' : null)"
        />
        <div>
          <p class="tourFilter_label">航空会社</p>
          <div
            v-for="{ name, code } in allFacets.transportations"
            :key="code"
          >
            <checkbox
              :label="name"
              :value="code"
              :selected="condition.transportations"
              :disabled="!shouldEnableTransportationCheckbox(code)"
              :strike-through="!facets.isTransportationSelectable(code) && condition.hasTransportation(code)"
              @change="updateTransportations($event)"
            />
          </div>
        </div>
        <div v-if="!condition.isDomestic">
          <p class="tourFilter_label">座席クラス</p>
          <tk-pulldown
            :value="condition.seatCode"
            :items="allFacets.seats.map(({ name, code }) => ({
              value: code,
              label: name,
            }))"
            :size="size"
            :disabled="isLoadingFacets"
            @change="update(params.SEAT_CODE, $event)"
          />
        </div>
        <div>
          <p class="tourFilter_label">発着時間</p>
          <p class="tourFilter_outboundTimeLabel">往路</p>
          <div class="tourFilter_outboundTime">
            <tk-pulldown
              class="tourFilter_flexPulldown"
              :value="condition.departurePlaceTimeCode"
              :items="allFacets.outwards.map(({ name, code }) => ({
                value: code,
                label: name,
              }))"
              :size="size"
              :disabled="isLoadingFacets"
              @change="update(params.DEPARTURE_PLACE_TIME_CODE, $event)"
            />
            <tk-pulldown
              v-if="!condition.isDomestic"
              class="tourFilter_flexPulldown -gap"
              :value="condition.destinationArrivalTimeCode"
              :items="allFacets.arrivals.map(({ name, code }) => ({
                value: code,
                label: name,
              }))"
              :size="size"
              :disabled="isLoadingFacets"
              @change="update(params.DESTINATION_ARRIVAL_TIME_CODE, $event)"
            />
          </div>
          <p class="tourFilter_returnTimeLabel">復路</p>
          <div class="tourFilter_returnTime">
            <tk-pulldown
              class="tourFilter_flexPulldown"
              :value="condition.destinationTimeCode"
              :items="allFacets.homewards.map(({ name, code }) => ({
                value: code,
                label: name,
              }))"
              :size="size"
              :disabled="isLoadingFacets"
              @change="update(params.DESTINATION_TIME_CODE, $event)"
            />
            <tk-pulldown
              v-if="!condition.isDomestic"
              class="tourFilter_flexPulldown -gap"
              :value="condition.departurePlaceArrivalTimeCode"
              :items="allFacets.returns.map(({ name, code }) => ({
                value: code,
                label: name,
              }))"
              :size="size"
              :disabled="isLoadingFacets"
              @change="update(params.DEPARTURE_PLACE_ARRIVAL_TIME_CODE, $event)"
            />
          </div>
        </div>
      </div>

      <p class="tourFilter_sectionLabel">ツアー/プランの詳細を指定する</p>
      <div
        class="tourFilter_section"
        :style="{ padding: contentPadding }"
      >
        <div>
          <p class="tourFilter_label -noMarginTop">食事</p>
          <template v-if="allFacets.meals.length > 0">
            <div
              v-for="{ name, codes } in allFacets.meals"
              :key="codes.join('|')"
            >
              <checkbox
                :label="name"
                :value="codes"
                :selected="condition.intentionIds"
                :disabled="!shouldEnableIntentionCheckbox(codes)"
                :strike-through="!facets.withoutPopularIntentions.isIntentionSelectable(codes)
                  && condition.hasIntention(codes)"
                @change="updateIntentions($event, codes)"
              />
            </div>
          </template>
          <p
            v-else
            class="tourFilter_noChoices"
          >
            選択可能な食事がありません
          </p>
        </div>
        <div>
          <p class="tourFilter_label">テーマ</p>
          <template v-if="allFacets.themes.length > 0">
            <div
              v-for="{ name, codes } in allFacets.themes"
              :key="codes.join('|')"
            >
              <checkbox
                :label="name"
                :value="codes"
                :selected="condition.intentionIds"
                :disabled="!shouldEnableIntentionCheckbox(codes)"
                :strike-through="!facets.withoutPopularIntentions.isIntentionSelectable(codes)
                  && condition.hasIntention(codes)"
                @change="updateIntentions($event, codes)"
              />
            </div>
          </template>
          <p
            v-else
            class="tourFilter_noChoices"
          >
            選択可能なテーマがありません
          </p>
        </div>
      </div>
    </div>
    <div :class="['tourFilter_bottom', { '-sticky': stickyButton }]">
      <span class="tourFilter_count">件数 {{ totalToursText }}</span>
      <tk-button
        class="tourFilter_filterButton"
        :disabled="isLoadingFacets"
        @click="$emit('filter')"
      >
        絞り込む
      </tk-button>
    </div>
  </div>
</template>

<script>
import { TkButton, TkCrossMark, TkIcon, TkPulldown, TkStarRating, TkTextBox } from '@ota-frontend/ui'
import { asNumber, hasIntersection } from '@ota-frontend/core/utils'
import { buildTourQueryFromSearchCondition, fetchBff } from '@/api'
import Checkbox from '@/components/Checkbox.vue'
import FilterConditionBadges from '@/components/FilterConditionBadges.vue'
import { Facets, SearchCondition } from '@/models'

export default {
  name: 'TourFilter',

  components: {
    Checkbox,
    TkButton,
    TkIcon,
    TkPulldown,
    TkStarRating,
    TkTextBox,
    TkCrossMark,
    FilterConditionBadges,
  },

  model: {
    prop: 'condition',
  },

  props: {
    condition: {
      type: SearchCondition,
      required: true,
    },
    size: {
      type: String,
      default: 'normal',  // normal, large, x-large, xx-large, xxx-large
    },
    title: {
      type: String,
      default: '',
    },
    selectableFilterPrices: {
      type: Array,
      default: () => [10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 120000, 140000, 160000,
        180000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 600000, 700000, 800000, 900000, 1000000],
    },
    selectableHotelRanks: {
      type: Array,
      default: () => [3, 4, 5].map(rate => ({
        name: `${'★'.repeat(rate)}（${rate}つ星以上）`,
        code: rate,
      })),
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
    maxNumberOfToursToDisplay: {
      type: Number,
      required: true,
    },
    // 各セクションのパディング
    contentPadding: {
      type: String,
      default: '0',  // CSS の padding に直接設定される文字列, e.g. '10px', '10px 8px'
    },
    // 検索ボタンを画面下部に固定するかどうか
    stickyButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoadingFacets: false,
      facets: new Facets(),
      total: 0,
      hotel: [
        { opened: false, term: '', city: '' },
        { opened: false, term: '', city: '' },
        { opened: false, term: '', city: '' },
        { opened: false, term: '', city: '' },
      ],
    }
  },

  computed: {
    params() {
      return SearchCondition.PARAMS
    },
    // これを BFF から受け取るようにすればコンポーネントの独立性が高まる
    allFacets() {
      return this.condition.facets
    },
    selectablePriceTo() {
      return this.condition.priceFrom
        ? this.selectableFilterPrices.filter(p => p >= this.condition.priceFrom)
        : this.selectableFilterPrices
    },
    // [{ name: String (city or prefecture name), city: String (city code) }, ... ]
    destinations() {
      // 例えば、目的地１として city_id だけ指定し、目的地２に country_id2 が指定した場合、
      // 目的地２がインデックス 0 の目的地１扱いになってしまう
      // whyNoHotelsAtDestination はインデックスに依存しているためずれてしまう...
      return this.condition.destinations.filter(d => d.isSpecified)
        .map(d => {
          const cityId = d.cityId || (district => district
            ? district.city_id
            : undefined
          )(this.condition.areas.findDistrictById(d.districtId))
          return {
            name: d.districtName || d.cityName || d.countryName || d.regionName,
            city: cityId && String(cityId),
          }
        })
    },
    selectedHotelsForEachDestination() {
      return this.condition.destinations.map(d => this.allFacets.filterHotelsByCodes(d.hotelIds))
    },
    selectedCampaigns() {
      return this.campaigns.filter(({ id }) => this.condition.campaignIds.includes(String(id)))
    },
    totalToursText() {
      if (this.isLoadingFacets) {
        return '- 件'
      }
      return this.maxNumberOfToursToDisplay < this.total
        ? `${this.maxNumberOfToursToDisplay.toLocaleString()}件以上`
        : `${this.total.toLocaleString()} 件`
    },
  },

  watch: {
    condition() {
      this.fetchFacets()
    },
  },

  beforeMount() {
    this.fetchFacets()
  },

  methods: {
    asNumber(value) {
      return asNumber(value)
    },
    updatePriceFrom(value) {
      this.$emit('input', this.condition.update({
        [this.params.PRICE_FROM]: asNumber(value),
        [this.params.PRICE_TO]: null,
      }))
    },
    disableCampaign(id) {
      const campaignIds = this.condition.campaignIds.filter(id_ => id_ !== String(id))
      this.update({ [this.params.CAMPAIGNS]: campaignIds })
    },
    openHotelSelect(index) {
      this.hotel[0].opened = this.hotel[1].opened = this.hotel[2].opened = this.hotel[3].opened = false
      this.hotel[index].opened = true
    },
    selectableHotelsOfDestination(index) {
      const state = this.hotel[index]
      return !this.destinations[index].city
        // 県だけ指定されている目的地のホテル達
        ? this.allFacets.hotels.filter(({ name, city, rank }) =>
          (!state.term || name.includes(state.term)) &&
          (!state.city || city === String(state.city)) &&
          (!this.condition.minHotelRank || rank >= this.condition.minHotelRank)
        )
        // 都市まで指定されている目的地のホテル達
        : this.allFacets.hotels.filter(({ name, city, rank }) =>
          (city === this.destinations[index].city) &&
          (!state.term || name.includes(state.term)) &&
          (!this.condition.minHotelRank || rank >= this.condition.minHotelRank)
        )
    },
    whyNoHotelsAtDestination(index) {
      switch (this.allFacets.reasonWhyNoHotelsAtDestination(index)) {
        case 'should-specify-country': return this.condition.isDomestic ? '都道府県まで含めて再検索してください' : '国名まで含めて再検索してください'
        case 'should-specify-city': return '都市名まで含めて再検索してください'
        default: return '選択可能なホテルがありません'
      }
    },
    selectHotel(selectedHotelCodes) {
      // 目的地として指定されている全都市
      const cities = this.destinations.filter(d => !!d.city).map(d => d.city)

      // 現在選択されている全ホテル (selectedHotelCodes) を hotel_id1～hotel_id4（最大で４つ）に配布していく
      const selectedHotelsForEachDestination = this.destinations.map(destination => {
        if (!destination.city) {  // 県までしか指定していない目的地（全目的地の中に１つだけ存在する可能性がある）
          // 現在選択されている全ホテル (selectedHotelCodes) のうち、所属都市がいずれの目的地にも含まれていないものはこの "県" の hotel_idX に入れる
          return selectedHotelCodes.filter(code_ => {
            const hotel = this.allFacets.findHotelByCode(code_)
            return hotel && !cities.some(city => String(city) === hotel.city)
          })
        } else {  // 都市まで指定されている目的地
          // 現在選択されている全ホテル (selectedHotelCodes) のうち、所属都市がこの目的地であるものをこの index に入れる
          const hotelsOfThisDestination = this.allFacets.filterHotelsByCity(destination.city)
          return selectedHotelCodes.filter(code => hotelsOfThisDestination.some(h => h.code === code))
        }
      })

      this.$emit('input', this.condition.selectHotels(
        selectedHotelsForEachDestination[0] || [],
        selectedHotelsForEachDestination[1] || [],
        selectedHotelsForEachDestination[2] || [],
        selectedHotelsForEachDestination[3] || [],
      ))
    },
    updateTransportations(selected) {
      const trains = selected.filter(code => this.allFacets.trains.some(t => t.code === code))
      const airlineIds = selected.filter(code => this.allFacets.airlines.some(a => a.code === code))
      this.$emit('input', this.condition.update({
        [this.params.TRAIN]: trains[0],
        [this.params.AIRLINES]: airlineIds,
      }))
    },
    shouldEnableIntentionCheckbox(codes) {
      if (this.isLoadingFacets) return false  // 件数読み込み中は disabled にしなければいけない

      // 対象ツアーありで選択可能、または既に選択中（再選択不可でも選択解除だけはできるようにしておく）
      return this.facets.withoutPopularIntentions.isIntentionSelectable(codes) || this.condition.hasIntention(codes)
    },
    shouldEnableTransportationCheckbox(code) {
      if (this.isLoadingFacets) return false  // 件数読み込み中は disabled にしなければいけない

      // 対象ツアーありで選択可能、または既に選択中（再選択不可でも選択解除だけはできるようにしておく）
      return this.facets.isTransportationSelectable(code) || this.condition.hasTransportation(code)
    },
    // チェックの ON OFF を確認するためだけに渡される selected が可読性を下げている
    updateIntentions(selected, codes) {
      const checked = hasIntersection(selected, codes)
      const updated = checked
        ? this.condition.selectIntention(codes)
        : this.condition.unselectIntention(codes)
      this.$emit('input', updated)
    },
    update(property, value) {
      this.$emit('input', this.condition.update({ [property]: value }))
    },
    async fetchFacets() {
      this.isLoadingFacets = true
      const { total, facets } = await fetchBff('tour/list/facets', buildTourQueryFromSearchCondition(this.condition))
        .catch(e => ({ total: this.total, facets: this.facets.raw }))  // 失敗したときは現在と同じ値にフォールバックしておく
      this.total = total
      this.facets = new Facets(facets, this.condition.isDomestic)
      this.isLoadingFacets = false
    },
  },
}
</script>

<style scoped lang="scss">
.tourListPage_tourFilter{
  display: flex;
  flex-direction: column-reverse;
}
.tourFilter_sectionLabel {
  padding: 10px 14px;
  background-color: #e7e7e7;
  font-size: 14px;
  font-weight: 600;
}

.tourFilter_section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tourFilter_campaign {
  display: table;
  width: 100%;
  height: 36px;
  margin: 5px 0;
  box-shadow: 1px 1px 3px 0px rgba(50, 50, 50, 0.4);
  background-color: #fff;

  @media (max-width: 657px) {
    height: 50px;
  }
}

.tourFilter_selectedIcon {
  display: table-cell;
  width: 72px;
  padding: 0 10px;
  background-image: url(~@ota-frontend/shared-assets/images/tour/flag_message.png);
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 62%;
}

.tourFilter_campaignText {
  display: table-cell;
  color: #0393d0;
  font-size: 12px;
  font-weight: bold;
  vertical-align: middle;

  @media (max-width: 657px) {
    font-size: 14px;
  }
}

.tourFilter_closeCampaign {
  float: right;
  width: 30px;
  height: 20px;
  margin: 10px 0px 10px 10px;
  border-left: 1px #82c9e7 solid;
  background-image: url(~@ota-frontend/shared-assets/images/tour/close_message.png);
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 50%;
  cursor: pointer;

  @media (max-width: 657px) {
    width: 40px;
    height: 30px;
  }
}

.tourFilter_lpIntentionArea {
  margin-top: 7px;
}

.tourFilter_title {
  padding: 8px 14px;
  color: #fff;
  background-color: #63666a;
  font-size: 17px;
  font-weight: bold;
  line-height: 1.42857143;
  box-shadow: 0 1px 4px #00000029;
}

.tourFilter_label {
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 600;

  &.-noMarginTop {
    margin-top: 0;
  }
}

.tourFilter_outboundTimeLabel,
.tourFilter_returnTimeLabel {
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 5px;
}

.tourFilter_flexPulldown {
  flex: 1;

  &.-gap {
    margin-left: 10px;
  }
}

.tourFilter_inputHotelName {
  margin-top: 8px;
}

.tourFilter_range {
  display: block;
  text-align: center;
  padding: 0 10px 0;
}

.tourFilter_noChoices {
  width: 100%;
  padding: 10px;
  color: #f9423a;
  font-weight: bold;
  text-align: center;
}

.tourFilter_budget {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tourFilter_hotelListBox {
  margin-top: 10px;
  margin-bottom: 10px;
  border: solid 1px #d2d2d2;
  border-radius: 4px;
}

.tourFilter_hotelList {
  max-height: 200px;
  padding: 6px;
  overflow: auto;
}

.tourFilter_hotelRank {
  display: inline-block;
  margin-left: 8px;
}

.tourFilter_closeHotelListArea {
  padding: 8px 0;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  background: #ebebeb;
  text-align: center;
  cursor: pointer;
}

.tourFilter_closeHotelList {
  display: inline-block;
  padding: 8px 40px;
  border-radius: 4px 4px;
  background: #f9423a;
  color: #fff;
  line-height: 1;
}

.tourFilter_selectedHotelsArea {
  margin-top: 12px;
  margin-bottom: 28px;
}

.tourFilter_selectedHotels {
  display: flex;
  align-items: center;
  margin: 4px 0;
  cursor: pointer;
}

.tourFilter_hotelUnselectButton {
  display: inline-block;
  width: 46px;
  height: 30px;
  padding: 8px 10px;
  background: #cdcdcd;
  color: #333;
  border-radius: 3px;
}

.tourFilter_hotelUnselectLabel {
  flex: 1;
  line-height: 20px;
  padding-left: 8px;
}

.tourFilter_bottom {
  position: sticky;
  top: 109px;
  display: flex;
  width: 100%;
  height: 63px;
  margin: 0 auto 20px;
  padding: 2%;
  background: #f6f6f6;
  align-items: center;

  &.-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: auto;
    bottom: 0;
    margin-bottom: 0;
  }
}

.tourFilter_count {
  display: block;
  width: 40%;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.tourFilter_filterButton {
  width: 55%;
  margin: 1px 0 0;
  padding: 13px 0 13px 10px;
  background: #F9423A url(https://www.tabikobo.com/tour/media/tabi_sp_files/img/common/ico_search.png) no-repeat 15px 50%;
  -webkit-background-size: 18px auto;
  background-size: 18px auto;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;

  &:disabled {
    background-color: #d2d2d2;
  }
}

.tourFilter_outboundTime {
  display: flex;
}

.tourFilter_returnTime {
  display: flex;
}

.tourFilter_radioButton {
  transform: scale(0.8);
  cursor: pointer;
}

.tourFilter_radioButtonLabel {
  height: 22px;
  font-size: 11px;
  cursor: pointer;
}

.tourFilter_allRemoveButton {
  position: relative;
  padding-top: 0;  // グローバルの打消し
  padding-left: 18px;  // グローバルの上書き
  color: #347AB0;
  font-size: 12px;
  font-weight: bold;
  border: 0;
  background-color: #fff;
  cursor: pointer;
}

.tourFilter_clearAllCrossMark {
  position: absolute;
  left: 0px;
  top: 4px;

  @media (max-width: 657px) {
    top: 6px;
  }
}

.tourFilter_filterBadgesList {
  border-top: dashed 1px #d2d2d2;
  padding-top: 8px;
}
</style>

<style lang="scss">
// 内部のスタイルをクラスで直接操作する仕様のため、scoped は使えない
.tourFilter_hotelRankLabel {
  display: none;
}
</style>
